/* Hoisted from snippets/sk-card-inline-picker.liquid (SK perf 2026-09-18): this script used to be inlined once PER PRODUCT CARD
   (30 copies per collection page, ~14 KB each: SK_CIP controller + swatch-row equalizer). It is now loaded once from layout/theme.liquid with defer.
   All init paths (DOMContentLoaded, shopify:section:load, body MutationObserver) are unchanged. */
if (!window.SK_CIP) {
  window.SK_CIP = {};

  /* Fallback color map for common names when swatch data is not configured */
  var SK_CIP_COLORS = {
    'black': '#111111', 'ink black': '#1c1c2e', 'jet black': '#0a0a0a',
    'white': '#e8e8e8', 'off white': '#f0ece4', 'cream': '#f3ede0',
    'navy': '#0f2557', 'sailor navy': '#0f2557', 'dark navy': '#0a1a40',
    'blue': '#2563a8', 'light blue': '#7fb3d3', 'sky blue': '#87ceeb', 'royal blue': '#1a4fa0',
    'red': '#c0392b', 'cherry red': '#b01020', 'brick red': '#a0321c',
    'green': '#2e7d32', 'olive': '#6b7c3b', 'field olive': '#6b7c3b', 'forest green': '#228b22', 'sage': '#8fad88',
    'grey': '#777777', 'gray': '#777777', 'charcoal': '#3c3c3c', 'heather grey': '#9a9a9a', 'light grey': '#c0c0c0',
    'brown': '#6d4c41', 'tan': '#c8a87a', 'camel': '#c19a6b', 'khaki': '#c3b48e',
    'pink': '#d06080', 'hot pink': '#e91e8c', 'blush': '#e8b4b8', 'mauve': '#b07080',
    'purple': '#7b3fa0', 'lavender': '#9b8bb0', 'violet': '#6a0dad', 'plum': '#8e3c8e',
    'orange': '#d4660a', 'rust': '#b84a18', 'burnt orange': '#c04a10', 'coral': '#e06050',
    'yellow': '#d4a500', 'gold': '#c8960a', 'mustard': '#c8960a', 'butter': '#e8d080',
    'teal': '#1a8080', 'turquoise': '#20b0a0', 'aqua': '#00b0c0', 'mint': '#88c8a0',
    'burgundy': '#7d1528', 'wine': '#6d1020', 'maroon': '#6d0020',
    'beige': '#d4c4a0', 'sand': '#c8b880', 'natural': '#d0c4a8',
    'denim': '#4a5c8a', 'chambray': '#5c7090',
    'heather brick': '#8b3a3a', 'heather mushroom': '#a08070', 'heather periwinkle': '#7070b0',
    'heather moss': '#7a8a6a', 'moss': '#7a8a6a',
    'ivory heather': '#ece5d6', 'ivory': '#ece5d6',
    'steel': '#6e7e8c', 'steel blue': '#6e7e8c', 'steel grey': '#6e7e8c', 'steel gray': '#6e7e8c'
  };

  function SK_CIP_fallbackColor(name) {
    var key = (name || '').toLowerCase().trim();
    if (SK_CIP_COLORS[key]) return SK_CIP_COLORS[key];
    for (var k in SK_CIP_COLORS) {
      if (key.indexOf(k) !== -1 || k.indexOf(key) !== -1) return SK_CIP_COLORS[k];
    }
    return '#888888';
  }

  window.SK_CIP.init = function(cip) {
    var variants;
    try { variants = JSON.parse(cip.querySelector('.sk-cip__json').textContent); }
    catch(e) { return; }

    /* Colors are rendered inside .card-gallery from Liquid — query them there.
       This means they are always in the overlay position with no layout impact.
       Note: card-gallery is a class on a div, not a custom element tag. */
    var card      = cip.closest('product-card');
    var gallery   = card && card.querySelector('.card-gallery');
    var colorsEl  = gallery && gallery.querySelector('.sk-cip__colors');
    var hasColors = !!colorsEl;
    var sizesEl   = gallery && gallery.querySelector('.sk-cip__sizes');
    var hasSizes  = !!sizesEl;
    var sel = { color: null, size: null, colorOp: 1, sizeOp: 2 };

    /* Build name→hex map from metafield color_properties (if present) */
    var metaColorMap = {};
    var colorMapEl = cip.querySelector('.sk-cip__colormap');
    if (colorMapEl) {
      try {
        JSON.parse(colorMapEl.textContent).forEach(function(c) {
          if (c.n && c.h) metaColorMap[c.n.toLowerCase().trim()] = c.h;
        });
      } catch(e) {}
    }

    /* Apply fallback colors to chips that have no inline style */
    if (colorsEl) {
      colorsEl.querySelectorAll('.sk-cip__chip').forEach(function(chip) {
        var key = (chip.dataset.v || '').toLowerCase().trim();
        if (metaColorMap[key]) {
          chip.style.background = metaColorMap[key];
        } else if (!chip.style.background) {
          chip.style.background = SK_CIP_fallbackColor(chip.dataset.v);
        }
      });
    }

    /* Pre-select first chip (always in-stock due to Liquid render order) and first available size */
    var firstChip = colorsEl && colorsEl.querySelector('.sk-cip__chip');
    if (firstChip) {
      sel.colorOp = parseInt(firstChip.dataset.op, 10) || 1;
      sel.color   = firstChip.dataset.v;
    }
    var firstSzBtn = sizesEl && sizesEl.querySelector('.sk-cip__sz:not(.oos)');
    if (firstSzBtn) {
      sel.sizeOp = parseInt(firstSzBtn.dataset.op, 10) || 2;
      sel.size   = firstSzBtn.dataset.v;
      firstSzBtn.classList.add('is-sel');
    }

    function findVariant() {
      return variants.find(function(v) {
        var cm = !hasColors || !sel.color || v['option' + sel.colorOp] === sel.color;
        var sm = !hasSizes  || !sel.size  || v['option' + sel.sizeOp]  === sel.size;
        return cm && sm && v.available;
      });
    }

    /* Navigate the card gallery to the slide matching the selected color. */
    function swapImage(colorName) {
      var card = cip.closest('product-card');
      if (!card) return;
      var chip = colorsEl && colorsEl.querySelector('.sk-cip__chip[data-v="' + colorName + '"]');
      if (!chip || !chip.dataset.mid) return;
      var targetId = chip.dataset.mid;

      var slideshow = card.refs && card.refs.slideshow;
      if (!slideshow) return;

      var allSlides = (slideshow.refs && slideshow.refs.slides) || [];

      /* Hide all variant slides except the target */
      for (var i = 0; i < allSlides.length; i++) {
        if (allSlides[i].getAttribute('variant-image') === null) continue;
        allSlides[i].hidden = allSlides[i].getAttribute('slide-id') !== targetId;
      }

      if (typeof slideshow.select === 'function') {
        slideshow.select({ id: targetId }, undefined, { animate: false });
      }
    }

    /* Update quick-add form + button visibility.
       When a valid variant exists: show add-to-cart button.
       When OOS (no available variant): hide the entire quick-add component. */
    function syncQuickAdd() {
      var card = cip.closest('product-card');
      if (!card) return;
      var form         = card.querySelector('form[data-type="add-to-cart-form"]');
      var vidInput     = form ? form.querySelector('input[name="id"]') : null;
      var quickAddComp = card.querySelector('quick-add-component');

      var v = findVariant();

      if (v) {
        if (vidInput) vidInput.value = v.id;
        if (quickAddComp) {
          quickAddComp.setAttribute('data-quick-add-button', 'add');
          quickAddComp.style.display = '';
        }
        var link = card.querySelector('[ref="cardGalleryLink"], .product-card__link');
        if (link && link.href) {
          try {
            var u = new URL(link.href);
            u.searchParams.set('variant', v.id);
            link.href = u.toString();
          } catch(e) {}
        }
      } else {
        /* OOS — hide the quick-add button entirely */
        if (quickAddComp) {
          quickAddComp.setAttribute('data-quick-add-button', 'choose');
          quickAddComp.style.display = 'none';
        }
      }

      /* Always swap image — even for OOS color selections */
      swapImage(sel.color);
    }

    /* Color chip click handlers */
    if (colorsEl) {
      colorsEl.querySelectorAll('.sk-cip__chip').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          colorsEl.querySelectorAll('.sk-cip__chip').forEach(function(b) { b.classList.remove('is-sel'); });
          btn.classList.add('is-sel');
          sel.color = btn.dataset.v;
          syncQuickAdd();
        });
      });
    }

    /* Size buttons — rendered in .card-gallery, query from sizesEl */
    if (sizesEl) {
      sizesEl.querySelectorAll('.sk-cip__sz:not(.oos)').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          sizesEl.querySelectorAll('.sk-cip__sz').forEach(function(b) { b.classList.remove('is-sel'); });
          btn.classList.add('is-sel');
          sel.size = btn.dataset.v;
          syncQuickAdd();
        });
      });
    }

    /* Initial sync — wait until slideshow.refs.slides is populated so swapImage works.
       Colors are already in card-gallery from server render; no DOM move needed.
       Retry up to ~500ms (10 × 50ms) before falling through. */
    function initSwap(attempts) {
      if (!card) return;
      var ss = card.refs && card.refs.slideshow;
      var slides = (ss && ss.refs && ss.refs.slides) || [];
      if (slides.length > 0 || attempts <= 0) {
        syncQuickAdd();
      } else {
        setTimeout(function() { initSwap(attempts - 1); }, 50);
      }
    }
    requestAnimationFrame(function() { initSwap(10); });
  };

  window.SK_CIP.initAll = function() {
    document.querySelectorAll('.sk-cip:not([data-cip-ok])').forEach(function(el) {
      el.dataset.cipOk = '1';
      window.SK_CIP.init(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.SK_CIP.initAll);
  } else {
    window.SK_CIP.initAll();
  }

  document.addEventListener('shopify:section:load', window.SK_CIP.initAll);

  new MutationObserver(function(muts) {
    var found = false;
    muts.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.nodeType === 1 && n.querySelector && n.querySelector('.sk-cip:not([data-cip-ok])')) found = true;
      });
    });
    if (found) window.SK_CIP.initAll();
  }).observe(document.body, { childList: true, subtree: true });
}
if (window.SK_CIP) window.SK_CIP.initAll();

/* ── Swatch-bar row equalizer (guarded so multiple renders only init once) ── */
if (!window._SK_EQ) {
  window._SK_EQ = true;
  (function () {
    /* Count visual columns of a grid from its computed grid-template-columns.
       This is resolved from CSS the moment the page parses and does NOT depend on
       images having loaded, so row grouping is STABLE during image decode. The old
       approach grouped cards by pixel top-offset, which shifts as each image loads,
       causing cards to hop between buckets run-to-run (titles jumping up/down). */
    function columnsOf(grid) {
      var tpl = '';
      try { tpl = getComputedStyle(grid).gridTemplateColumns; } catch (e) {}
      if (tpl && tpl !== 'none') {
        var n = tpl.split(' ').filter(function (s) { return s && s !== '0px'; }).length;
        if (n >= 1) return n;
      }
      return 0;
    }
    /* Equalize one visual row: no-swatch cards get bottom padding equal to the
       tallest swatch bar in the row, so all titles align. Idempotent — sets the
       same value every run, so repeated calls (resize, image load) cause no flash. */
    function equalizeRow(row) {
      var barsInRow = row.filter(function (g) { return !!g.querySelector('.sk-cip__bar'); });
      if (row.length < 2 || !barsInRow.length) {
        row.forEach(function (g) {
          if (!g.querySelector('.sk-cip__bar') && g.style.paddingBlockEnd) {
            g.style.removeProperty('padding-block-end');
            g.style.marginBottom = '';
          }
        });
        return;
      }
      var barHeight = Math.max.apply(null, barsInRow.map(function (g) {
        return g.querySelector('.sk-cip__bar').offsetHeight;
      }));
      var target = barHeight + 'px';
      row.forEach(function (g) {
        if (!g.querySelector('.sk-cip__bar')) {
          if (g.style.paddingBlockEnd !== target) {
            g.style.setProperty('padding-block-end', target, 'important');
          }
          g.style.marginBottom = 'calc(var(--product-card-gap, 0px) * -1)';
        }
      });
    }
    function run() {
      var grids = Array.from(document.querySelectorAll('[data-testid="product-grid"], .product-grid'));
      if (!grids.length) return;
      grids.forEach(function (grid) {
        var galleries = Array.from(grid.querySelectorAll('.card-gallery'));
        if (!galleries.length) return;
        var cols = columnsOf(grid);
        if (cols >= 1) {
          /* Group consecutive galleries into rows of `cols`. DOM order matches visual
             order in a CSS grid, so this is exact and immune to image-load reflow. */
          for (var i = 0; i < galleries.length; i += cols) {
            equalizeRow(galleries.slice(i, i + cols));
          }
        } else {
          /* Fallback (non-grid layout): treat the whole grid as one row. */
          equalizeRow(galleries);
        }
      });
    }
    var debounceTimer;
    function schedule(delay) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(run, delay || 150);
    }
    /* Run as EARLY as possible (DOMContentLoaded), before images load. Swatch bars
       have their height immediately, and column count comes from CSS, so padding is
       set correctly up front and every later run is a no-op = no post-load jump. */
    if (document.readyState !== 'loading') { run(); }
    else { document.addEventListener('DOMContentLoaded', run); }
    window.addEventListener('load', run);
    window.addEventListener('resize', function () { schedule(150); });
    function observeGrids() {
      document.querySelectorAll('[data-testid="product-grid"], .product-grid').forEach(function (grid) {
        if (grid._skEqObserved) return;
        grid._skEqObserved = true;
        new MutationObserver(function () { schedule(150); }).observe(grid, { childList: true });
      });
      document.querySelectorAll('product-recommendations').forEach(function (el) {
        if (el._skEqObserved) return;
        el._skEqObserved = true;
        new MutationObserver(function () { schedule(600); }).observe(el, { childList: true, subtree: true });
      });
    }
    new MutationObserver(function () { observeGrids(); schedule(150); }).observe(document.body, { childList: true, subtree: false });
    observeGrids();
  }());
}
